import {VEHICLES_ACTION_PREFIX} from '../../modules/organization/store/vehicles/vehicles.actions';
import {DashboardRow} from '../../modules/dashboard/models/dashboard-rows.model';

export const SHARED_STATE_ACTION_PREFIX = '[Cost State]';

export class SearchCost {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Search cost`;
  constructor(public keyword: string) { }
}

export class SetSpinner {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Set Spinner`;
  constructor(public isEnable: boolean, public message?: string) { }
}

export class LoadCountryById {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} load Country`;
  constructor(public countryId?: string) { }
}

export class LoadOrgById {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} load Organization`;
  constructor(public orgId: string) { }
}

export class ResetSharedState {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Reset State`;
}

export class GetVehicleCategories {
  static readonly type = `${VEHICLES_ACTION_PREFIX} fetch vehicle categories`;

  constructor(public isStandard?: boolean) {
  }
}

export class SetSkeletonLoader {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Set Skeleton Loader`;
  constructor(public isEnable: boolean) { }
}

export class UpdateDashboardRows {
  static readonly type = '[Dashboard] Update Dashboard Rows';
  constructor(public dashboardRows: DashboardRow[]) {}
}

export class GetOrgUserById {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Get Org User By Id`;
  constructor(public orgId: string, public orgUserId: string) { }
}

export class FetchOrgUserPhoto {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Fetch Org User Photo`;
  constructor(public orgUserId: string) { }
}

export class SetDownloadProgress {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Set Download Progress`;
  constructor(public progress: number, public downloadType: string, public fileName?: string) { }
}

export class ClearDownloadProgress {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Clear Download Progress`;
  constructor(public downloadType: string) { }
}

export class SetBulkUploadResult {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Set Bulk Upload Result`;
  constructor(public bulkUploadResult: any) { }
}

export class ClearBulkUploadResult {
  static readonly type = `${SHARED_STATE_ACTION_PREFIX} Clear Bulk Upload Result`;
}